import React, { useContext, useEffect, useRef } from 'react';
import zoomInIcon from '../../assets/roadmap-control-panel/zoom-in.svg';
import zoomOutIcon from '../../assets/roadmap-control-panel/zoom-out.svg';
import cssClass from './RoadmapControlPanel.module.css';
import previewIcon from '../../assets/roadmap-control-panel/preview-icon.svg';
import publishIcon from '../../assets/roadmap-control-panel/publish-icon.svg';
import sidePeekIcon from '../../assets/roadmap-control-panel/side-peek-icon.svg';
import propertiesIcon from '../../assets/roadmap-control-panel/properties-icon.svg';
import { SidebarContext } from '../../context/SidebarContext';
import { useParams } from 'react-router-dom';
import { emitCustomEvent } from '../../utils/helper';
import { RoadmapContext } from '../../context/RoadmapContext';
import { useReactFlow } from '@xyflow/react';

/**
 *
 * @description This component is used to render the control panel for the roadmap. It contains buttons for zooming in and out, previewing the roadmap, publishing the roadmap, and showing properties.
 * @returns {JSX.Element}
 * @component
 * @example
 * return (<RoadmapControlPanel />)
 */
const RoadmapControlPanel = () => {
  const { activeSection, setActiveSection } = useContext(SidebarContext);
  const {
    roadmapVisibility,
    setRoadmapVisibility,
    roadmapStatus,
    setRoadmapSatus,
  } = useContext(RoadmapContext);
  const { zoomIn, zoomOut } = useReactFlow();
  const { roadmap_id } = useParams();
  const roadmpaControlPanelRef = useRef(null);

  const handleZoomIn = () => {
    zoomIn({ duration: 300 });
  };
  const handleZoomOut = () => {
    zoomOut({ duration: 300 });
  };

  const handlePreviewButtonClick = () => {
    window.open(`/preview/${roadmap_id}`, '_blank');
  };

  const handleRoadmapPublish = () => {
    const newVisibility = roadmapVisibility === 'public' ? 'private' : 'public';
    const newStatus = roadmapStatus === 'draft' ? 'published' : 'draft';
    setRoadmapVisibility(newVisibility);
    setRoadmapSatus(newStatus);
    emitCustomEvent('roadmap::update', {
      visibility: newVisibility,
      status: newStatus,
      change: 'visibility',
    });
  };

  useEffect(() => {
    if (activeSection && roadmpaControlPanelRef.current) {
      roadmpaControlPanelRef.current.style.left = 'calc(80px + 205px)';
      // roadmpaControlPanelRef.current.style.width = 'calc(100vw - 205px - 85px)';
    } else {
      roadmpaControlPanelRef.current.style.left = 'calc(80px)';
      // roadmpaControlPanelRef.current.style.width = 'calc(100vw - 80px - 5px)';
    }
  }, [activeSection]);

  return (
    // <div className={cssClass['main-container']} ref={roadmpaControlPanelRef}>
    <>
      <div className={cssClass['zoom-control']} ref={roadmpaControlPanelRef}>
        <img
          src={zoomInIcon}
          alt=""
          title="zoom-in"
          className={cssClass['zoom-in']}
          onClick={handleZoomIn}
        />
        <img
          src={zoomOutIcon}
          alt=""
          title="zoom-out"
          className={cssClass['zoom-out']}
          onClick={handleZoomOut}
        />
      </div>

      {/* <div className={cssClass['control-btns']}>
        <button
          className={cssClass['preview-btn']}
          onClick={handlePreviewButtonClick}
        >
          <img
            src={previewIcon}
            alt="preview-icon"
            className={cssClass['preview-btn-img']}
          />
          <div className={cssClass['preview-btn-text']}>Preview</div>
        </button>

        <button
          className={cssClass['publish-btn']}
          onClick={handleRoadmapPublish}
        >
          <img
            src={publishIcon}
            alt="publish-icon"
            className={cssClass['publish-btn-img']}
          />
          <div className={cssClass['preview-btn-text']}>
            {roadmapVisibility === 'public' ? 'Unpublish' : 'Publish'}
          </div>
        </button>

        <button className={cssClass['side-peek-btn']}>
          <img
            src={sidePeekIcon}
            alt="sude-peek-icon"
            className={cssClass['sude-peek-btn-img']}
          />
          <div className={cssClass['side-peek-btn-text']}>Side Peek</div>
        </button>

        <button className={cssClass['properties-btn']}>
          <img
            src={propertiesIcon}
            alt="properties-icon"
            className={cssClass['properties-btn-img']}
          />
          <div className={cssClass['properties-btn-text']}>Properties</div>
        </button>
      </div> */}
    </>
    // </div>
  );
};

export default RoadmapControlPanel;
